<template>
    <validation-provider
        v-slot="{ classes, errors }"
        class="text-input pt-2"
        tag="div"
        :rules="rules"
        :name="name"
        :vid="vid"
    >
        <label class="input__label label--default" :for="name">
            {{ name }}
            <span v-if="classes['required']">*</span>
        </label>
        <input
            v-model="actualValue"
            class="text-input__input input--default input--rounded"
            :type="type"
            :class="classes"
            :placeholder="placeholder"
            :readonly="readonly"
            @change="emitValue"
        />
        <span class="input-error">{{ errors[0] }}</span>
    </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
    components: {
        ValidationProvider
    },

    props: {
        value: {
            type: String,
            default: ''
        },
        rules: {
            type: [String, Object],
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        vid: {
            type: String,
            default: undefined
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            actualValue: ''
        };
    },
    watch: {
        value: function() {
            this.actualValue = this.value;
        }
    },
    mounted() {
        this.actualValue = this.value;
    },
    methods: {
        emitValue() {
            this.$emit('input', this.actualValue);
        }
    }
};
</script>

<style lang="scss">
.text-input__input {
    width: 100%;
    font-size: 1.125rem;
    border-radius: 5px;
    padding: 10px;
    line-height: 1;
    border: none;

    &:focus {
        outline: none;
        opacity: 1;
    }
}
</style>
